import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=7340d747"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7340d747')) {
      api.createRecord('7340d747', component.options)
    } else {
      api.reload('7340d747', component.options)
    }
    module.hot.accept("./Logout.vue?vue&type=template&id=7340d747", function () {
      api.rerender('7340d747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/Logout.vue"
export default component.exports